import { render, staticRenderFns } from "./QuestionLoader.vue?vue&type=template&id=4b8a25c0&scoped=true"
import script from "./QuestionLoader.vue?vue&type=script&lang=js"
export * from "./QuestionLoader.vue?vue&type=script&lang=js"
import style0 from "./QuestionLoader.vue?vue&type=style&index=0&id=4b8a25c0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8a25c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pikkle/Dev/eM+/muse/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b8a25c0')) {
      api.createRecord('4b8a25c0', component.options)
    } else {
      api.reload('4b8a25c0', component.options)
    }
    module.hot.accept("./QuestionLoader.vue?vue&type=template&id=4b8a25c0&scoped=true", function () {
      api.rerender('4b8a25c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Survey/View/Loader/QuestionLoader.vue"
export default component.exports